import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    SEARCH_USERS,
    SEARCH_USERS_SUCCESS,
    SEARCH_USERS_FAILED,
    VIEW_USERS,
    VIEW_USERS_SUCCESS,
    VIEW_USERS_FAILED,
    UPDATE_USERS,
    UPDATE_USERS_SUCCESS,
    UPDATE_USERS_FAILED,
    CREATE_USERS,
    CREATE_USERS_SUCCESS,
    CREATE_USERS_FAILED,
    CHANGE_STATUS_USER,
    CHANGE_STATUS_USER_SUCCESS,
    CHANGE_STATUS_USER_FAILED,
    RESET_STATUS,
    BACK_TO_LOGIN,
    CHANGE_PASSWORD_USER,
    CHANGE_PASSWORD_USER_SUCCESS,
    CHANGE_PASSWORD_USER_FAILED,
    GET_MERCHANT_AND_ROLE_SEARCH
} from "constants/ActionTypes";
import {
    searchUserApi,
    viewUserApi,
    createUserApi,
    updateUserApi,
    changeStatusUserApi,
    changePasswordUserApi,
} from "../../appRedux/api/User";
import {
    mapPagingToRecordInfo,
    mapUserSearchRow,
    mapUserDetail,
} from "../../appRedux/api/authHelpers";
import {fetchViewMerchant, fetchSearchSubMerchant} from "./Merchant";
import {fetchSearchRoles} from "./Roles";
import { apiHandler, AUTH_MUTATION_SUCCESS } from "./handler";

export function* fetchSearchUser({ payload }) {
    const { ok, data, message } = yield* apiHandler(searchUserApi, payload);

    if (ok) {
        const rows = Array.isArray(data.body) ? data.body : [];
        yield put({
            type: SEARCH_USERS_SUCCESS,
            payload: {
                data: {
                    content: rows.map(mapUserSearchRow),
                },
                recordInfo: mapPagingToRecordInfo(data.paging),
            },
        });
    } else {
        yield put({
            type: SEARCH_USERS_FAILED,
            payload: message,
        });
    }
}

function* fetchViewUser({payload}) {
    if(payload != null){
        const { ok, data, message } = yield* apiHandler(viewUserApi, payload);

        if (ok) {
            const detail = mapUserDetail(data.body || {});
            const legacyPayload = { data: detail };
            yield put({type: VIEW_USERS_SUCCESS, payload: legacyPayload});
            localStorage.setItem("userData", JSON.stringify(legacyPayload));
        } else {
            yield put({type: VIEW_USERS_FAILED, payload: message});
        }
    }
}

function* postEditUser({payload}) {
    if(payload != null){
        yield put({type: RESET_STATUS});
        const { ok, data, message } = yield* apiHandler(updateUserApi, payload, {
            successCodes: AUTH_MUTATION_SUCCESS,
        });

        if (ok) {
            yield put({type: UPDATE_USERS_SUCCESS, payload: data.body || data.data});
        } else {
            yield put({type: UPDATE_USERS_FAILED, payload: message});
        }
    }
}

function* postInsertUser({payload}) {
    if(payload != null){
        yield put({type: RESET_STATUS});
        const { ok, data, message } = yield* apiHandler(createUserApi, payload, {
            successCodes: AUTH_MUTATION_SUCCESS,
        });

        if (ok) {
            yield put({type: CREATE_USERS_SUCCESS, payload: { data: data.body, ...data }});
        } else {
            yield put({type: CREATE_USERS_FAILED, payload: message});
        }
    }
}

function* postChangeStatusUser({payload}) {
    if(payload != null){
        const { ok, data, message } = yield* apiHandler(changeStatusUserApi, payload, {
            successCodes: AUTH_MUTATION_SUCCESS,
        });

        if (ok) {
            yield put({type: CHANGE_STATUS_USER_SUCCESS, payload: data.body || data.data});
        } else {
            yield put({type: CHANGE_STATUS_USER_FAILED, payload: message});
        }
    }
}

function* postChangePasswordUser({payload}) {
    const { ok, data, message } = yield* apiHandler(changePasswordUserApi, payload, {
        successCodes: AUTH_MUTATION_SUCCESS,
    });

    if (ok) {
        yield put({type: CHANGE_PASSWORD_USER_SUCCESS, payload: data});
    } else {
        yield put({type: CHANGE_PASSWORD_USER_FAILED, payload: message});
    }
}

function* fetchViewSearchMerchantAndSearchRoles(param){
    yield call(fetchViewMerchant,param);
    yield call(fetchSearchSubMerchant,param);
    yield call(fetchSearchRoles, {
        ...(param || {}),
        payload: {
            ...((param && param.payload) || param || {}),
            size: 1000,
            fetchAll: true,
        },
    });
}


export function* searchUser() {
    yield takeEvery(SEARCH_USERS, fetchSearchUser);
}

export function* viewUser(){
    yield takeEvery(VIEW_USERS, fetchViewUser);
}

export function* editUser(){
    yield takeEvery(UPDATE_USERS, postEditUser);
}

export function* createUser(){
    yield takeEvery(CREATE_USERS, postInsertUser);
}

export function* changePassword() {
    yield takeEvery(CHANGE_PASSWORD_USER, postChangePasswordUser);
}

export function* changeStatusUser(){
    yield takeEvery(CHANGE_STATUS_USER, postChangeStatusUser);
}

export function* getMerchantAndRole(){
    yield takeEvery(GET_MERCHANT_AND_ROLE_SEARCH, fetchViewSearchMerchantAndSearchRoles);
}

export default function* rootSaga() {
    yield all([
        fork(searchUser),
        fork(changeStatusUser),
        fork(viewUser),
        fork(editUser),
        fork(createUser),
        fork(changePassword),
        fork(getMerchantAndRole)
    ]);
}
